<template>
    <div class="trained-machine-value">
        <span v-if="displayPower">Puissance nominale de la machine entrainée : <span>{{computePnMe}} kW</span></span>
    </div>
</template>

<script>
    export default {
        name: 'TrainedMachinePowerValue',
        props:{
            motor:{
                type: Object,
                required: true,
            },
            trainedMachine:{
                type: Object,
                required: true,
            }
        },
        data(){
            return {
                
            }
        },
        computed:{
            displayPower(){
                return this.computePnMe !== undefined && this.computePnMe !== '0';
            },
            computePnMe(){
                try{
                    let theoreticalEfficiency = this.motor.nominal_power / (Math.sqrt(3) * this.motor.nominal_voltage * this.motor.nominal_current * this.motor.cos_phi / 1000);

                    let machinePnMe = this.computePowerForFlowAndPressureInWatt({
                        flowValue: this.trainedMachine.flow,
                        flowUnit: this.trainedMachine.flow_unit,
                        pressureValue: this.trainedMachine.pressure,
                        pressureUnit: this.trainedMachine.pressure_unit,
                        fluidType: this.motor.application_type.endsWith('ventilation') ? 'air' : 'eau',
                        efficiency: this.trainedMachine.efficiency,
                    });

                    //Convert in kW
                    machinePnMe = machinePnMe / 1000;

                    return new Intl.NumberFormat('fr-FR', { style: 'decimal' }).format(machinePnMe.toFixed(3));
                }catch(e){
                    return undefined;
                }
                
            }
        },
        methods:{
            getFlowInMeterCubePerSecond(value, unit){
                if (unit === 'm³/s') {
                    return value;
                }
                else if (unit === 'm³/min') {
                    return value / 60;
                }
                else if (unit === 'm³/h') {
                    return value / 3600;
                }
                throw new Error(`Invalid unit for flow : ${unit}`);
            },

            getPressureInPa(value, unit){
                if (unit === 'Pa') {
                    return value;
                }
                else if (unit === 'bar') {
                    return value * Math.pow(10, 5);
                }
                else if (unit === 'mCe') {
                    const hauteurManometriqueTotale = 10.1972;
                    return value * Math.pow(10, 5) / hauteurManometriqueTotale;
                }
                throw new Error(`Invalid unit for pressure : ${unit}`);
            },

            getDensity(fluidType){
                if(fluidType === 'air'){
                    return 1.08;
                }
                else if(fluidType === 'eau'){
                    return 0.999564033;
                }
                throw new Error(`Invalid fluid type : ${fluidType}`);
            },


            computePowerForFlowAndPressureInWatt({flowValue, flowUnit, pressureValue, pressureUnit, fluidType, efficiency}){
                let flow = this.getFlowInMeterCubePerSecond(flowValue, flowUnit);
                let pressure = this.getPressureInPa(pressureValue, pressureUnit);
                let density = this.getDensity(fluidType);
                return (flow*pressure*density)/(efficiency)
                
            },
        }
    }
</script>

<style lang="scss">
    .trained-machine-value{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
    }

</style>


// WEBPACK FOOTER //
// src/components/partials/wizard/TrainedMachinePowerValue.vue